import Preloader from "../../components/preloader";

export default function Access() {
	return (
		<div className="preloader-wrapper">
			<Preloader />
		</div>
	);
}
